/** A weekday as JavaScript and cron count it: 0 = Sunday … 6 = Saturday. */
export type NxWeekday = 0 | 1 | 2 | 3 | 4 | 5 | 6;

/**
 * RFC 5545 day codes by `NxWeekday` („mo“ for 1), lower case as the calendar
 * stores them — for turning a picked day into an RRULE `BYDAY` and back.
 */
export const NX_WEEKDAY_CODES = ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'] as const;

/** The seven days in display order, starting with `firstDay` (1 = Monday). */
export function weekdayOrder(firstDay = 1): NxWeekday[] {
  const start = ((Math.trunc(firstDay) % 7) + 7) % 7;
  return Array.from({ length: 7 }, (_, i) => ((start + i) % 7) as NxWeekday);
}

/**
 * Localized day names indexed by `NxWeekday`. `short` drops the trailing dot
 * German abbreviations carry („Mo.“ → „Mo“), so a row of chips stays even.
 */
export function weekdayNames(
  locale: string,
  style: 'long' | 'short' | 'narrow' = 'long'
): string[] {
  const format = new Intl.DateTimeFormat(locale, { weekday: style, timeZone: 'UTC' });
  // 2024-01-07 is a Sunday, so day d of that week is weekday d.
  return Array.from({ length: 7 }, (_, d) => {
    const name = format.format(new Date(Date.UTC(2024, 0, 7 + d)));
    return style === 'long' ? name : name.replace(/\.$/, '');
  });
}
